// actionModal.js (renamed from successModal.js)
import { createModal } from './modal.js';
import { currLang } from '@/scripts/translation.js';

function buildActionContent({
  heading,
  buttonLabel,
  onAction,
  closeOnAction = true,
  variant = 'success',
  showButton = true,
  cancelLabel, // NEW — pass to render an explicit secondary Cancel button
  onCancel, // NEW — optional, runs before the modal closes on cancel
  modalApi,
}) {
  const wrapper = document.createElement('div');
  wrapper.className = `action-modal action-modal--${variant} bg-cream`;

  if (heading) {
    const headingEl = document.createElement('p');
    headingEl.className = 'action-modal__heading';
    headingEl.textContent = heading;
    wrapper.appendChild(headingEl);
  }

  if (showButton) {
    const actionsContainer = document.createElement('div');
    actionsContainer.className = 'modal-actions';
    actionsContainer.style.display = 'flex';
    actionsContainer.style.justifyContent = 'center';
    actionsContainer.style.gap = '12px';
    actionsContainer.style.marginTop = '24px';

    if (cancelLabel) {
      const cancelBtn = document.createElement('button');
      cancelBtn.type = 'button';
      cancelBtn.className = 'modal-btn'; // reuse the existing generic secondary button style
      cancelBtn.textContent = cancelLabel;
      cancelBtn.addEventListener('click', () => {
        if (onCancel) onCancel();
        modalApi.close();
      });
      actionsContainer.appendChild(cancelBtn);
    }

    const actionBtn = document.createElement('button');
    actionBtn.type = 'button';
    actionBtn.className = `action-modal__btn action-modal__btn--${variant}`;
    actionBtn.textContent = buttonLabel || currLang['UI.Ok'];

    actionBtn.addEventListener('click', () => {
      if (onAction) onAction();
      if (closeOnAction) modalApi.close();
    });

    actionsContainer.appendChild(actionBtn);
    wrapper.appendChild(actionsContainer);
  }

  return wrapper;
}

export function createActionModal(getContent) {
  let modalApi;

  modalApi = createModal({
    closable: true,
    size: 'md',
    content: () => buildActionContent({ ...getContent(), modalApi }),
    onClose: () => {
      const data = getContent();
      if (data.onClose) data.onClose();
    },
  });

  return modalApi;
}